import * as EmailValidator from "email-validator";


// function to check if input is valid email format
export const isValidEmailFormat = (input: string) : boolean => {
    return EmailValidator.validate(input);
}


// function to check if input is valid phone format
export const isValidPhoneFormat = (input: string): boolean => {
    const validRegex = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
    return !!input.match(validRegex);

}

export const isValidFirstOrLastName = (input: string) : boolean => {
    const validRegex = "^[A-Za-z]+$";
    if(input.match(validRegex)) {
        return true;
    }
    return false;

}